__turbopack_context__.v({
  "backgroundImage": "Yh_oSG_backgroundImage",
  "backgroundImageWrapper": "Yh_oSG_backgroundImageWrapper",
  "contentWrapper": "Yh_oSG_contentWrapper",
  "desktopImage": "Yh_oSG_desktopImage" + " " + "Yh_oSG_backgroundImage",
  "mobileImage": "Yh_oSG_mobileImage" + " " + "Yh_oSG_backgroundImage",
  "paragraph": "Yh_oSG_paragraph" + " " + __turbopack_context__.i(527070)["body1"],
  "section": "Yh_oSG_section",
  "textContent": "Yh_oSG_textContent",
  "word": "Yh_oSG_word",
});
